import {
  ADD_TO_BASKET,
  CLEAR_BASKET,
  CLEAR_BASKET_AFTER_ORDER,
} from "../constants/actionTypes";
import { AddToBasketPayloadType, ClearBasketAction } from "../types/line-items";

export function addToBasket(payload: AddToBasketPayloadType) {
  return { type: ADD_TO_BASKET, payload };
}

export function clearBasket(): ClearBasketAction {
  return { type: CLEAR_BASKET };
}

export function clearBasketAfterOrder() {
  return { type: CLEAR_BASKET_AFTER_ORDER };
}
